// import { usePage } from 'frontend/src/contexts/PageUse';

import styled from 'styled-components'
import UtilWrapper from 'frontend/src/components/util/UtilWrapper';
import SidebarContainer from 'frontend/src/components/sidebar/SidebarContainer';
import { usePage } from '../../contexts/PageProvider';
import { TypeBodyM } from '../../styles/mixins';
import { Columns } from '../../styles/functions';
import SanityContent from '../sanity/content/SanityContent';
import PageFooter from './PageFooter';

function PageStockists() {
  const page = usePage();

  return (
    <>
    <Container>
      <Sidebar isSticky={true} />
      
      <Content 
        layout="STOCKISTS" 
        blocks={page.stockists}  
      />
      
    </Container>
    <PageFooter />
    </>
  )
}

const Container = styled(UtilWrapper)`
margin-top: var(--spacing-page-top);
`

const Sidebar = styled(SidebarContainer)`


`

const Content = styled(SanityContent)`
  ${TypeBodyM}
`

// const Footer = styled.div`
//   grid-column: 1 / -1;
// `

export default PageStockists
